module.exports = __webpack_public_path__ + "img/client-6.jpg?a80a9e0410b371ccb3c54b087e2f30b8";